<script setup lang="ts">
import ProgressSpinner from 'primevue/progressspinner'
</script>
<template>
    <div class="w-full h-full flex justify-center items-center p-1">
        <ProgressSpinner class="w-[4rem] h-[4rem]" />
    </div>
</template>
